import React from "react";

import { reduxForm, SubmissionError, formValues, Field, change } from "redux-form";
import fetchJsonp from "fetch-jsonp";
import qs from "query-string";
import { useMutation } from '@apollo/client';
import gql from "graphql-tag";

import removeHash from "src/utils/location";
import WithUserForm from "../../Register/WithUserForm";
import Step from "../Step";

import isChecked from "./insta-checkmark.svg";

import styles from "../styles.module.css";
import withHooks, {
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
} from "react-with-hooks";
import {withRouter} from "react-router-dom";
import blankImage from "../../../assets/images/blank.gif";
import Spinner from "../../../assets/Spinner/Spinner";
import CTAButton from "../../utils/Button/CTAButton";

const maxNumberOfImages = 6;
const minNumberOfImages = 6;

const SelectPhotos = withHooks((props) => {
  const imagesRef = useRef();

  useEffect(() => {
    let timeOutClassNextPage;
    if (props.isNextPage) {
      timeOutClassNextPage = props.handleNextPage();
    }

    return () => {
      if (timeOutClassNextPage) {
        clearTimeout(timeOutClassNextPage);
      }
    };
  }, [props.isNextPage]);

  useEffect(() => {
    if(imagesRef.current) {
      imagesRef.current.addEventListener("scroll", function() {
        if (
            imagesRef.current.scrollHeight -
            Math.abs(imagesRef.current.scrollTop) <=
            imagesRef.current.clientHeight + 1
        ) {
          props.setIsNextPage(true);
        }
      });
    }
  }, [imagesRef.current]);

  return (
      <>
        <p className={`${styles.select_photos_text}`}
           style={{marginBottom: "10px"}}
        >
          Nice work! Your account
          <br />
          @{props.connectedInstagramHandle || "Unknown"}{" "} is connected.
        </p>
        {/* Display a red warning message if the Instagram account has fewer than 6 photos */}
        {props.imageData?.images?.length < 6 && (
          <p className={`${styles.error_message} ${styles.default_text_size}`}
             style={{margin: "5px 0 20px 0"}}
          >
            Your Instagram account has less than 6 photos.  <br/>
            You need at least 6 photos to continue.
          </p>
        )}
        {props.imageData?.images?.length >= 6 && (
            <p className={`${styles.select_photos_text}`}
               style={{marginBottom: "2.5vh"}}
            >
              Please select 6 images from your<br/>
              account that best represent you.
            </p>
        )}
        <div className="w-full relative">
          <>
            {props.imageData?.images?.length >= 6 && (
              <div className={`${styles.list_image}`} ref={imagesRef}>
                {props.imageData.images.map((image) => (
                    <div
                        className={styles.image}
                        key={image.id}
                        onClick={() => props.selectImage(image)}
                    >
                      <img src={blankImage} style={{ backgroundImage: `url(${image.media_url})`}} alt="" />
                      {props.imagesSelected &&
                          props.imagesSelected.map(
                              (imageSelected) =>
                                  image.id === imageSelected.id && (
                                      <img
                                          key={image.id}
                                          className={styles.selected_image}
                                          src={isChecked}
                                          alt="error"
                                      />
                                  ),
                          )}
                    </div>
                ))}
              </div>
            )}
            <div className={props.classNextPage}/>
          </>
          {/* Display the pictures even if there are fewer than 6 */}
          {/* The user is not allowed to select them */}
          {props.imageData?.images?.length < 6 && (
              <div className={`${styles.list_image} ${styles.few_images}`}>
                {props.imageData.images.map((image) => (
                    <div
                        className={`${styles.image}`}
                        style={{
                          cursor: "default"
                        }}
                        key={image.id}
                    >
                      <img src={blankImage} style={{backgroundImage: `url(${image.media_url})`}} alt=""/>
                    </div>
                ))}
              </div>
          )}
        </div>
        {props.imageData?.images?.length >= 6 && (<div className={styles.step_five_action_container}>
          <div className={`${styles.select_photos_text}`}>
              {props.imagesSelected && props.imagesSelected.length}/6 images selected
          </div>
        </div>)}
        {(!props.imageData?.images || props.imageData?.images?.length < 6) && <p className={`${styles.p} ${styles.notEnoughImages}`}>
          Instagram is a model’s, actor’s and performer’s lookbook. Please
          have at least {minNumberOfImages} photos in your Instagram account
          showing your best work and then come back and register with us.
        </p>}
      </>
  );
});

let Form = withHooks(
  ({
    form: { handleSubmit },
    machine,
    selectImage,
    imagesSelected,
    handleNextPage,
    classNextPage,
    setIsNextPage,
    isNextPage,
    imageData,
     connectedInstagramHandle,
  }) => {
    const [data, setData] = useState({});

    useLayoutEffect(() => {
      if (imageData) {
        setData(imageData);
      }
    }, [imageData]);

    const footer = (
        <div
            style={{
              width: '90vw',
              maxWidth: '400px',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-end',
              paddingBottom: '10px'
            }}
        >
          {imageData?.images?.length >= 6 && <div style={{width: '100%', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {/* Center cta button in available space between text and footer*/}
            <CTAButton
                onClick={handleSubmit}
                disabled={imagesSelected.length < 6}
                text={'Confirm'}
            />
          </div>}
          <p
              className={`${styles.default_text_size}`}
              style={{
                color: '#B08D57',
                lineHeight: 0.9
              }}
          >
            Having trouble? <a href="https://wa.me/443330166335" style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Contact us</a>.
          </p>
        </div>
    );
    return (
        <Step footer={footer} centerContent={imageData?.images?.length < 6}>
          <form
              onSubmit={handleSubmit}
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
              }}
          >
          <Field
            name="images"
            component={SelectPhotos}
            maxNumberOfImages={maxNumberOfImages}
            selectImage={selectImage}
            imagesSelected={imagesSelected}
            handleNextPage={handleNextPage}
            classNextPage={classNextPage}
            setIsNextPage={setIsNextPage}
            isNextPage={isNextPage}
            onBack={() => machine.service.send({ type: "BACK" })}
            imageData={data}
            connectedInstagramHandle={connectedInstagramHandle}
          />
          </form>
        </Step>
    );
  },
);

Form = formValues("images")(Form);


let StepFive = ({ history, dispatch }) => {
  const [instagramToken, setInstagramToken] = useState();
  const [imagesSelected, setImagesSelected] = useState([]);
  const [imageData, setImageData] = useState({});
  const [isNextPage, setIsNextPage] = useState(false);
  const [classNextPage, setClassNextPage] = useState("");
  const [connectedInstagramHandle, setConnectedInstagramHandle] = useState(null);
  const [getThumbnail] = useMutation(INSTAGRAM_THUMBNAIL_URL);
  useEffect(() => {
    if(instagramToken){
      getImages();
    }
  }, [instagramToken]);

  const handleSelectImage = (image) => {
    const index = imagesSelected.findIndex((img) => img.id === image.id);
    const  newImageList = [...imagesSelected];
    if (newImageList.length <= 6 && index > -1) {
      newImageList.splice(index, 1);
    } else if (newImageList.length < 6) {
      newImageList.push(image);
    }
    setImagesSelected(newImageList);
  };

  const handleImages = async (body) => {
    let images = [];
    const media = body.data.filter(
        (m) => m.media_type === "IMAGE" || m.media_type === "CAROUSEL_ALBUM"
    );

    if (media.length > 0) {
      for (const post of media) {
        if (post.children) {
          const children = post.children.data.filter(
              (child) => child.media_type === "IMAGE" || child.media_type === "CAROUSEL_ALBUM"
          );
          if (children.length > 0) {
            const rootPermalink = children[0].permalink;
            children.forEach((c, i) => {
              c.carouselRootPermalink = rootPermalink;
              c.carouselChildIndex = i + 1;
            });
            images = images.concat(children);
          }
        } else {
          images.push(post);
        }
      }
      setConnectedInstagramHandle(media[0].username);
    }

    setImageData((prev) => ({
      images: [...(prev?.images || []), ...images],
      paging: body.paging,
    }));

    for (const post of media) {
      if (post.media_type === "CAROUSEL_ALBUM") {
        for (const child of post.children.data) {
          await retrieveThumbnail(child);
        }
      } else {
        await retrieveThumbnail(post);
      }
    }
  };

  const handleNextPage = async () => {
    if (!imageData?.paging?.next) return;
    const res = await fetchJsonp(imageData.paging.next).then((res) => res.json());
    setClassNextPage(styles.list_image_active_next_page);
    setTimeout(() => setClassNextPage(""), 2000);
    await handleImages(res);
    setIsNextPage(false);
  };

  const getImages = async () => {
    removeHash();
    const query = qs.stringify({ access_token: instagramToken });
    const res = await fetchJsonp(
        `https://graph.instagram.com/v21.0/me/media/?fields=id,media_type,media_url,permalink,children{media_type,media_url,permalink},username&${query}`
    ).then((res) => res.json())
    .catch(error => {
      // Failed to fetch instagram account images, invalid token
      console.log(error);
      history.push("/apply/instagram");
    });
    if (res.error) {
      // Failed to fetch instagram account images, invalid token
      console.log(res.error);
      history.push("/apply/instagram");
    }
    await handleImages(res);
  };

  const retrieveThumbnail = async (media) => {
    try {
      media.thumbnail_url = await getThumbnail({
        variables: {
          instagramMediaPermalink: media.permalink,
          large: true,
        },
      }).then((res) => res.data.instagramThumbnailUrl);
    } catch (e) {
      console.error("Thumbnail error:", e);
    }
  };

  const onSubmit = async (values, _, formProps) => {
    if (imagesSelected.length < 6) {
      throw new SubmissionError({
        images: `Please select at least ${minNumberOfImages} photos.`,
      });
    }

    const formattedValues = WithUserForm.formatUserPhotosInput({
      ...values,
      images: imagesSelected,
      connectedInstagramHandle,
    });

    dispatch(change("apply", "images", imagesSelected));
    dispatch(change("apply", "connectedInstagramHandle", connectedInstagramHandle));

    await formProps.updateUserPhotos({ variables: { input: formattedValues } });
    formProps.machine.service.send({ type: "NEXT" });
  };
  return (
      <WithUserForm onSubmit={onSubmit}>
        {(formProps) => {
          useEffect(() => {
            const dbInstagramAccessToken = formProps.userQuery?.data?.currentUser?.instagramToken;
            if(!dbInstagramAccessToken) {
              history.push("/apply/instagram");
            }
            setInstagramToken(dbInstagramAccessToken);
          }, []);
          return (
              <>
                {!connectedInstagramHandle &&
                    <div className={styles.Loading}>
                      <Spinner color='white' />
                    </div>
                }
                {!!connectedInstagramHandle && <Form
                    {...formProps}
                    imageData={imageData}
                    imagesSelected={imagesSelected}
                    selectImage={handleSelectImage}
                    getImages={setImagesSelected}
                    handleNextPage={handleNextPage}
                    classNextPage={classNextPage}
                    isNextPage={isNextPage}
                    setIsNextPage={setIsNextPage}
                    connectedInstagramHandle={connectedInstagramHandle}
                />}
              </>
          )
        }}
      </WithUserForm>
  );
};


const INSTAGRAM_THUMBNAIL_URL = gql`
  mutation instagramThumbnailUrl(
    $instagramMediaPermalink: String
    $large: Boolean
  ) {
    instagramThumbnailUrl(instagramMediaPermalink: $instagramMediaPermalink, large: $large)
  }
`;
const withInstagramThumbnailUrl = (Component) => (props) => {
  const [instagramThumbnailUrl] = useMutation(INSTAGRAM_THUMBNAIL_URL);
  return <Component {...props} instagramThumbnailUrl={instagramThumbnailUrl} />;
};

StepFive = withInstagramThumbnailUrl(StepFive);

StepFive = reduxForm({
  form: "apply",
  enableReinitialize: true,
  destroyOnUnmount: false,
})(StepFive);

export default withRouter(StepFive);